import { render, staticRenderFns } from "./imsSales.vue?vue&type=template&id=66ec9aed&scoped=true&"
import script from "./imsSales.vue?vue&type=script&lang=js&"
export * from "./imsSales.vue?vue&type=script&lang=js&"
import style0 from "./imsSales.vue?vue&type=style&index=0&id=66ec9aed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ec9aed",
  null
  
)

export default component.exports